<template>
  <transition name="view" appear>
    <div class="k8m-cluster-wrapper">
      <router-view />
    </div>
  </transition>
</template>
<script>
export default {
  name: 'K8MCluster',
};
</script>

<style lang="scss" scoped>
.k8m-cluster-wrapper {
  margin-top: 1em;
  height: 94%;
}
</style>
